

export const diagnosisQualifiers = {
  "ABK": {
    "description": "Principal Diagnosis",
    "type": "ICD-10-CM"
  },
  "ABF": {
    "description": "Other Diagnosis",
    "type": "ICD-10-CM"
  },
  "APR": {
    "description": "Patient's Reason for Visit",
    "type": "ICD-10-CM"
  },
  "ABJ": {
    "description": "Admitting Diagnosis",
    "type": "ICD-10-CM"
  },
  "BE": {
    "description": "External Cause of Injury",
    "type": "ICD-10-CM"
  },
  "BH": {
    "description": "Diagnosis Related Group (DRG)",
    "type": "DRG"
  },
  "BJ": {
    "description": "Principal Procedure",
    "type": "ICD-10-PCS"
  },
  "BK": {
    "description": "Other Procedure",
    "type": "ICD-10-PCS"
  },
  "BG": {
    "description": "Diagnosis Related Group",
    "type": "DRG"
  },
  "B0": {
    "description": "Principal Diagnosis",
    "type": "ICD-9-CM"
  },
  "B1": {
    "description": "Other Diagnosis",
    "type": "ICD-9-CM"
  },
  "B2": {
    "description": "Admitting Diagnosis",
    "type": "ICD-9-CM"
  },
  "B3": {
    "description": "External Cause of Injury",
    "type": "ICD-9-CM"
  },
  "BR": {
    "description": "Patient's Reason for Visit",
    "type": "ICD-9-CM"
  },
  "BBR": {
    "description": "Patient's Reason for Visit",
    "type": "ICD-10-CM"
  },
  "BI": {
    "description": "Principal Diagnosis",
    "type": "SNOMED"
  }
}

export const icd9CmData = {
  Infectious_and_Parasitic_Diseases: {
    rangeStart: "001",
    rangeEnd: "139",
    color: "#e74c3c",
    icon: "Virus"
  },
  Neoplasms: {
    rangeStart: "140",
    rangeEnd: "239",
    color: "#8e44ad",
    icon: "DNA"
  },
  Endocrine_Nutritional_and_Metabolic_Diseases: {
    rangeStart: "240",
    rangeEnd: "279",
    color: "#f39c12",
    icon: "Activity"
  },
  Diseases_of_the_Blood_and_Blood_Forming_Organs: {
    rangeStart: "280",
    rangeEnd: "289",
    color: "#2c3e50",
    icon: "Droplet"
  },
  Mental_Disorders: {
    rangeStart: "290",
    rangeEnd: "319",
    color: "#e67e22",
    icon: "Brain"
  },
  Nervous_System_and_Sense_Organs: {
    rangeStart: "320",
    rangeEnd: "389",
    color: "#3498db",
    icon: "BrainCircuit"
  },
  Circulatory_System: {
    rangeStart: "390",
    rangeEnd: "459",
    color: "#c0392b",
    icon: "Heart"
  },
  Respiratory_System: {
    rangeStart: "460",
    rangeEnd: "519",
    color: "#2980b9",
    icon: "Wind"
  },
  Digestive_System: {
    rangeStart: "520",
    rangeEnd: "579",
    color: "#27ae60",
    icon: "Stethoscope"
  },
  Genitourinary_System: {
    rangeStart: "580",
    rangeEnd: "629",
    color: "#9b59b6",
    icon: "Droplets"
  },
  Complications_of_Pregnancy_Childbirth_and_the_Puerperium: {
    rangeStart: "630",
    rangeEnd: "679",
    color: "#e84393",
    icon: "Baby"
  },
  Skin_and_Subcutaneous_Tissue: {
    rangeStart: "680",
    rangeEnd: "709",
    color: "#d35400",
    icon: "Paintbrush"
  },
  Musculoskeletal_System: {
    rangeStart: "710",
    rangeEnd: "739",
    color: "#7f8c8d",
    icon: "Bone"
  },
  Congenital_Anomalies: {
    rangeStart: "740",
    rangeEnd: "759",
    color: "#fdcb6e",
    icon: "Sparkles"
  },
  Conditions_Originating_in_the_Perinatal_Period: {
    rangeStart: "760",
    rangeEnd: "779",
    color: "#fd79a8",
    icon: "BabyIcon"
  },
  Symptoms_Signs_and_Ill_defined_Conditions: {
    rangeStart: "780",
    rangeEnd: "799",
    color: "#636e72",
    icon: "ActivitySquare"
  },
  Injury_and_Poisoning: {
    rangeStart: "800",
    rangeEnd: "999",
    color: "#d63031",
    icon: "Syringe"
  },
  Supplementary_Classification_of_Factors_Influencing_Health: {
    rangeStart: "V01",
    rangeEnd: "V91",
    color: "#00b894",
    icon: "UserCircle"
  },
  Supplementary_Classification_of_External_Causes_of_Injury: {
    rangeStart: "E000",
    rangeEnd: "E999",
    color: "#e17055",
    icon: "AlertTriangle"
  }
};


export const icd10CmData = {
  Certain_Infectious_and_Parasitic_Diseases: {
    rangeStart: "A00",
    rangeEnd: "B99",
    color: "#e74c3c",
    icon: "Virus"
  },
  Neoplasms: {
    rangeStart: "C00",
    rangeEnd: "D49",
    color: "#8e44ad",
    icon: "DNA"
  },
  Blood_and_Blood_forming_Organs: {
    rangeStart: "D50",
    rangeEnd: "D89",
    color: "#2c3e50",
    icon: "Droplet"
  },
  Endocrine_Nutritional_and_Metabolic_Diseases: {
    rangeStart: "E00",
    rangeEnd: "E89",
    color: "#f39c12",
    icon: "Activity"
  },
  Mental_and_Behavioural_Disorders: {
    rangeStart: "F01",
    rangeEnd: "F99",
    color: "#e67e22",
    icon: "Brain"
  },
  Nervous_System: {
    rangeStart: "G00",
    rangeEnd: "G99",
    color: "#3498db",
    icon: "BrainCircuit"
  },
  Eye_and_Adnexa: {
    rangeStart: "H00",
    rangeEnd: "H59",
    color: "#1abc9c",
    icon: "Eye"
  },
  Ear_and_Mastoid_Process: {
    rangeStart: "H60",
    rangeEnd: "H95",
    color: "#16a085",
    icon: "Ear"
  },
  Circulatory_System: {
    rangeStart: "I00",
    rangeEnd: "I99",
    color: "#c0392b",
    icon: "Heart"
  },
  Respiratory_System: {
    rangeStart: "J00",
    rangeEnd: "J99",
    color: "#2980b9",
    icon: "Wind"
  },
  Digestive_System: {
    rangeStart: "K00",
    rangeEnd: "K95",
    color: "#27ae60",
    icon: "Stethoscope"
  },
  Skin_and_Subcutaneous_Tissue: {
    rangeStart: "L00",
    rangeEnd: "L99",
    color: "#d35400",
    icon: "Paintbrush"
  },
  Musculoskeletal_System: {
    rangeStart: "M00",
    rangeEnd: "M99",
    color: "#7f8c8d",
    icon: "Bone"
  },
  Genitourinary_System: {
    rangeStart: "N00",
    rangeEnd: "N99",
    color: "#9b59b6",
    icon: "Droplets"
  },
  Pregnancy_Childbirth_and_the_Puerperium: {
    rangeStart: "O00",
    rangeEnd: "O9A",
    color: "#e84393",
    icon: "Baby"
  },
  Certain_Conditions_Originating_in_the_Perinatal_Period: {
    rangeStart: "P00",
    rangeEnd: "P96",
    color: "#fd79a8",
    icon: "BabyIcon"
  },
  Congenital_Malformations: {
    rangeStart: "Q00",
    rangeEnd: "Q99",
    color: "#fdcb6e",
    icon: "Sparkles"
  },
  Symptoms_Signs_and_Abnormal_Findings: {
    rangeStart: "R00",
    rangeEnd: "R99",
    color: "#636e72",
    icon: "ActivitySquare"
  },
  Injury_Poisoning_and_External_Causes: {
    rangeStart: "S00",
    rangeEnd: "T88",
    color: "#d63031",
    icon: "Syringe"
  },
  External_Causes_of_Morbidity: {
    rangeStart: "V00",
    rangeEnd: "Y99",
    color: "#e17055",
    icon: "AlertTriangle"
  },
  Factors_Influencing_Health_Status: {
    rangeStart: "Z00",
    rangeEnd: "Z99",
    color: "#00b894",
    icon: "UserCircle"
  }
};


// BH and DR qualifiers use DRG codes
export const drgData = {
  Nervous_System: {
    rangeStart: "001",
    rangeEnd: "039",
    color: "#6c5ce7",
    icon: "BrainCircuit"
  },
  Eye: {
    rangeStart: "040",
    rangeEnd: "061",
    color: "#00cec9",
    icon: "Eye"
  },
  Ear_Nose_Mouth_Throat: {
    rangeStart: "062",
    rangeEnd: "103",
    color: "#0984e3",
    icon: "Ear"
  },
  Respiratory_System: {
    rangeStart: "104",
    rangeEnd: "113",
    color: "#74b9ff",
    icon: "Wind"
  },
  Circulatory_System: {
    rangeStart: "215",
    rangeEnd: "316",
    color: "#d63031",
    icon: "Heart"
  },
  Digestive_System: {
    rangeStart: "329",
    rangeEnd: "395",
    color: "#00b894",
    icon: "Stethoscope"
  },
  Hepatobiliary_System_and_Pancreas: {
    rangeStart: "405",
    rangeEnd: "446",
    color: "#ffeaa7",
    icon: "Droplet"
  },
  Musculoskeletal_System: {
    rangeStart: "453",
    rangeEnd: "566",
    color: "#636e72",
    icon: "Bone"
  },
  Skin_Subcutaneous_Tissue_and_Breast: {
    rangeStart: "570",
    rangeEnd: "607",
    color: "#e17055",
    icon: "Paintbrush"
  },
  Endocrine_Nutritional_and_Metabolic: {
    rangeStart: "625",
    rangeEnd: "647",
    color: "#fdcb6e",
    icon: "Activity"
  },
  Kidney_and_Urinary_Tract: {
    rangeStart: "652",
    rangeEnd: "700",
    color: "#6c5ce7",
    icon: "Droplets"
  },
  Male_Reproductive_System: {
    rangeStart: "707",
    rangeEnd: "730",
    color: "#9b59b6",
    icon: "Male"
  },
  Female_Reproductive_System: {
    rangeStart: "734",
    rangeEnd: "761",
    color: "#e84393",
    icon: "Female"
  },
  Pregnancy_Childbirth_and_Puerperium: {
    rangeStart: "765",
    rangeEnd: "782",
    color: "#fab1a0",
    icon: "Baby"
  },
  Blood_and_Blood_Forming_Organs: {
    rangeStart: "800",
    rangeEnd: "817",
    color: "#2c3e50",
    icon: "Droplet"
  },
  Myeloproliferative_Disorders: {
    rangeStart: "820",
    rangeEnd: "849",
    color: "#b2bec3",
    icon: "ActivitySquare"
  },
  Infectious_and_Parasitic: {
    rangeStart: "853",
    rangeEnd: "872",
    color: "#e74c3c",
    icon: "Virus"
  },
  Mental_Disorders: {
    rangeStart: "880",
    rangeEnd: "897",
    color: "#e67e22",
    icon: "Brain"
  },
  Alcohol_Drug_Use_and_Dependence: {
    rangeStart: "894",
    rangeEnd: "897",
    color: "#d35400",
    icon: "Wine"
  },
  Injuries_Poisonings_and_Toxic_Effects: {
    rangeStart: "901",
    rangeEnd: "923",
    color: "#ff7675",
    icon: "Syringe"
  },
  Burns: {
    rangeStart: "927",
    rangeEnd: "933",
    color: "#e17055",
    icon: "Flame"
  },
  Factors_Influencing_Health_Status: {
    rangeStart: "939",
    rangeEnd: "951",
    color: "#00cec9",
    icon: "UserCircle"
  },
  Multiple_Significant_Trauma: {
    rangeStart: "955",
    rangeEnd: "959",
    color: "#dfe6e9",
    icon: "AlertTriangle"
  },
  HIV_Infections: {
    rangeStart: "969",
    rangeEnd: "977",
    color: "#55efc4",
    icon: "ShieldAlert"
  },
  Error_Unclassified_And_Other: {
    rangeStart: "981",
    rangeEnd: "999",
    color: "#b2bec3",
    icon: "HelpCircle"
  }
};


export const conditionCodes = {
  // 01–09: Work, insurance, accident related
  Employment_Insurance_Accident: {
    color: "#1abc9c",
    icon: "Briefcase",
    description: "Work-related conditions, insurance coverage, and accident-related incidents",
    codes: [
      { code: "01", label: "Military Service Related" },
      { code: "02", label: "Condition is Employment Related" },
      { code: "03", label: "Patient Covered by Insurance Not Listed" },
      { code: "04", label: "HMO/Other Managed Care Plan" },
      { code: "05", label: "Liability Insurance Involved" },
      { code: "06", label: "Worker's Compensation" },
      { code: "07", label: "Black Lung" },
      { code: "08", label: "Beneficiary Preferred Provider Organization" },
      { code: "09", label: "Other Accident" }
    ]
  },

  // 10–19: Auto accidents, other liability
  Auto_and_Liability: {
    color: "#e74c3c",
    icon: "Car",
    description: "Auto accidents, liability cases, and related insurance matters",
    codes: [
      { code: "10", label: "Auto Accident" },
      { code: "11", label: "Auto Accident/No Insurance" },
      { code: "12", label: "Other Accident" },
      { code: "13", label: "Medical Coverage" },
      { code: "14", label: "Attorney/No Fault Insurance" },
      { code: "15", label: "Other Liability" },
      { code: "16", label: "PIP (Personal Injury Protection) or Other No-Fault Insurance" },
      { code: "17", label: "Accident Medical Coverage" },
      { code: "18", label: "Other Accident" },
      { code: "19", label: "Other Liability" }
    ]
  },

  // 20–29: Coverage & accident liability
  Coverage_and_Accidents: {
    color: "#3498db",
    icon: "ShieldAlert",
    description: "Billing preferences, coverage denials, and employment-related accidents",
    codes: [
      { code: "20", label: "Beneficiary Requested Billing" },
      { code: "21", label: "Billing for Denial (Not Payable Under Payer Policy)" },
      { code: "22", label: "Patient Declined a Service" },
      { code: "23", label: "Second Surgical Opinion Required" },
      { code: "24", label: "Second Surgical Opinion" },
      { code: "25", label: "Sympathetic Condition" },
      { code: "26", label: "VA Eligible Patient Chooses to Receive Services in a Non-VA Facility" },
      { code: "27", label: "Patient Refused Preadmission Testing" },
      { code: "28", label: "Patient and/or Spouse is Employed" },
      { code: "29", label: "Accident Employment Related" }
    ]
  },

  // 30–39: Clinical trials, newborn, pregnancy
  Clinical_Pregnancy_Newborn: {
    color: "#e67e22",
    icon: "Baby",
    description: "Clinical trials, pregnancy-related care, and newborn services",
    codes: [
      { code: "30", label: "Qualified Clinical Trial" },
      { code: "31", label: "Patient Declined Home Health Service" },
      { code: "32", label: "Patient Transferred" },
      { code: "33", label: "Patient is Pregnant" },
      { code: "34", label: "Patient is in Labor" },
      { code: "35", label: "Delivery Occurred" },
      { code: "36", label: "General Care Patient in Hospital" },
      { code: "37", label: "Newborn Care" },
      { code: "38", label: "Newborn Readmission" },
      { code: "39", label: "Newborn at Mother's Side" }
    ]
  },

  // 40–49: Transfer, patient status
  Transfer_and_Status: {
    color: "#9b59b6",
    icon: "LogIn",
    description: "Patient transfers, admissions changes, and special patient circumstances",
    codes: [
      { code: "40", label: "Same Day Transfer" },
      { code: "41", label: "Partial Hospitalization" },
      { code: "42", label: "Continuing Care Not Related to Inpatient Admission" },
      { code: "43", label: "Special Contract/Plan" },
      { code: "44", label: "Inpatient Admission Changed by Physician" },
      { code: "45", label: "Ambiguous Gender" },
      { code: "46", label: "Patient Is Homeless" },
      { code: "47", label: "Transfer From Another Home Health Agency" },
      { code: "48", label: "Psychiatric Patient" },
      { code: "49", label: "PPD Skin Test / Special Code" }
    ]
  },

  // 50–59: Hospice, home health
  Hospice_HomeHealth: {
    color: "#2ecc71",
    icon: "Home",
    description: "Hospice care, home health services, and related certifications",
    codes: [
      { code: "50", label: "Hospice Related" },
      { code: "51", label: "Hospice Not Related" },
      { code: "52", label: "Home Care Provided by Another HHA" },
      { code: "53", label: "Hospice Not Certified" },
      { code: "54", label: "Hospice Provided Concurrently" },
      { code: "55", label: "Hospice Room and Board Only" },
      { code: "56", label: "Hospice Service Terminated" },
      { code: "57", label: "Hospice Service Revoked" },
      { code: "58", label: "Hospice Election Period" },
      { code: "59", label: "Home Health Services Terminated" }
    ]
  },

  // 60–69: Outlier, day limits, special cases
  Outliers_and_Special: {
    color: "#f39c12",
    icon: "Clock",
    description: "Outlier payments, day limits, and special billing circumstances",
    codes: [
      { code: "60", label: "Day Outlier" },
      { code: "61", label: "Cost Outlier" },
      { code: "62", label: "Payer Outlier" },
      { code: "63", label: "Other Outlier" },
      { code: "64", label: "Facility Outlier" },
      { code: "65", label: "Quality Outlier" },
      { code: "66", label: "Day Outlier Per Review Organization" },
      { code: "67", label: "Cost Outlier Day" },
      { code: "68", label: "DRG Special Payment" },
      { code: "69", label: "Day Outlier (Alternate)" }
    ]
  },

  // 70–79: Drugs, assignment, others
  Drugs_and_Assignment: {
    color: "#c0392b",
    icon: "Pill",
    description: "Self-administered drugs, provider assignments, and billing adjustments",
    codes: [
      { code: "70", label: "Self-Administered Drug" },
      { code: "71", label: "Patient Refused Service" },
      { code: "72", label: "Payer Refund" },
      { code: "73", label: "Adjustment on Prior Claim" },
      { code: "74", label: "Noncovered Level of Care / Not Medically Necessary" },
      { code: "75", label: "SNF Bed Not Available" },
      { code: "76", label: "Provider Accepts Assignment" },
      { code: "77", label: "Provider Does Not Accept Assignment" },
      { code: "78", label: "New Coverage Not Implemented by Managed Care Plan" },
      { code: "79", label: "Cost Report Filing" }
    ]
  },

  // 80–89: Home health and skilled nursing
  Home_Health_SNF: {
    color: "#16a085",
    icon: "Building",
    description: "Home health services in institutional settings and special care arrangements",
    codes: [
      { code: "80", label: "Home Health Service Provided in SNF" },
      { code: "81", label: "Home Health Service Provided in Hospice" },
      { code: "82", label: "Non-Routine Service" },
      { code: "83", label: "Special Case" },
      { code: "84", label: "Home Health Aide Service Hours" },
      { code: "85", label: "Focused Medical Review" },
      { code: "86", label: "Cataract Surgery" },
      { code: "87", label: "Laser Eye Surgery" },
      { code: "88", label: "Vision Therapy" },
      { code: "89", label: "Services Provided to Patient in SNF" }
    ]
  },

  // 90–99: Miscellaneous special codes
  Special_Services: {
    color: "#8e44ad",
    icon: "Star",
    description: "Special services, experimental procedures, and miscellaneous conditions",
    codes: [
      { code: "90", label: "Patient is Blind" },
      { code: "91", label: "Patient is Disabled" },
      { code: "92", label: "Patient has End Stage Renal Disease" },
      { code: "93", label: "Student Patient" },
      { code: "94", label: "Reserved for National Use" },
      { code: "95", label: "Reserved for State Use" },
      { code: "96", label: "Reserved for State Use" },
      { code: "97", label: "Reserved for State Use" },
      { code: "98", label: "Reserved for State Use" },
      { code: "99", label: "Reserved for State Use" }
    ]
  },

  // A0–A9: Special occurrence codes
  Special_Occurrence_A: {
    color: "#d35400",
    icon: "AlertTriangle",
    description: "Special occurrence codes for unique billing situations",
    codes: [
      { code: "A0", label: "Reserved" },
      { code: "A1", label: "Birthdate - Insured A" },
      { code: "A2", label: "Effective Date - Insured A Policy" },
      { code: "A3", label: "Benefits Exhausted" },
      { code: "A4", label: "Split Bill Date" },
      { code: "A5", label: "Deductible Met" },
      { code: "A6", label: "Coinsurance Day Begin" },
      { code: "A7", label: "Coinsurance Day End" },
      { code: "A8", label: "Reserved" },
      { code: "A9", label: "Reserved" }
    ]
  },

  // B0–B9: Special occurrence codes
  Special_Occurrence_B: {
    color: "#27ae60",
    icon: "Calendar",
    description: "Additional special occurrence codes for billing and coverage dates",
    codes: [
      { code: "B0", label: "Reserved" },
      { code: "B1", label: "Birthdate - Insured B" },
      { code: "B2", label: "Effective Date - Insured B Policy" },
      { code: "B3", label: "Benefits Exhausted - Insured B" },
      { code: "B4", label: "Split Bill Date - Insured B" },
      { code: "B5", label: "Deductible Met - Insured B" },
      { code: "B6", label: "Coinsurance Day Begin - Insured B" },
      { code: "B7", label: "Coinsurance Day End - Insured B" },
      { code: "B8", label: "Reserved" },
      { code: "B9", label: "Reserved" }
    ]
  },

  // C0–C9: Special occurrence codes
  Special_Occurrence_C: {
    color: "#2980b9",
    icon: "FileText",
    description: "Additional special occurrence codes for extended billing scenarios",
    codes: [
      { code: "C0", label: "Reserved" },
      { code: "C1", label: "Birthdate - Insured C" },
      { code: "C2", label: "Effective Date - Insured C Policy" },
      { code: "C3", label: "Benefits Exhausted - Insured C" },
      { code: "C4", label: "Split Bill Date - Insured C" },
      { code: "C5", label: "Deductible Met - Insured C" },
      { code: "C6", label: "Coinsurance Day Begin - Insured C" },
      { code: "C7", label: "Coinsurance Day End - Insured C" },
      { code: "C8", label: "Reserved" },
      { code: "C9", label: "Reserved" }
    ]
  },

  // D0–D9: Administrative adjustments
  Administrative_Adjustments: {
    color: "#34495e",
    icon: "Edit",
    description: "Administrative changes and claim adjustments",
    codes: [
      { code: "D0", label: "Change to Service Dates" },
      { code: "D1", label: "Change to Charges" },
      { code: "D2", label: "Change to Revenue/HCPCS/Units" },
      { code: "D3", label: "Second Change to Charges" },
      { code: "D4", label: "Change in Diagnosis" },
      { code: "D5", label: "Cancel to Correct HIC/Member ID" },
      { code: "D6", label: "Cancel Only to Replace with Correct Claim" },
      { code: "D7", label: "Change to DRG/Clinical" },
      { code: "D8", label: "Cancel to Correct HIC/Member ID (alternate)" },
      { code: "D9", label: "Change to Admit Date" }
    ]
  },

  // E0–E9: Additional administrative codes
  Extended_Administrative: {
    color: "#7f8c8d",
    icon: "Settings",
    description: "Extended administrative codes for complex billing adjustments",
    codes: [
      { code: "E0", label: "Change to Patient Status" },
      { code: "E1", label: "Change to Patient Discharge Status" },
      { code: "E2", label: "Change to Condition Codes" },
      { code: "E3", label: "Change to Occurrence Codes and Dates" },
      { code: "E4", label: "Change to Occurrence Span Codes and Dates" },
      { code: "E5", label: "Change to Value Codes and Amounts" },
      { code: "E6", label: "Change to UB-04 Header Information" },
      { code: "E7", label: "Change to Treatment Authorization Codes" },
      { code: "E8", label: "Change to Other Procedure Codes" },
      { code: "E9", label: "Change to Principal Procedure Code and Date" }
    ]
  },

  // F0–F9: Additional codes
  Additional_Codes_F: {
    color: "#95a5a6",
    icon: "Plus",
    description: "Additional codes for specialized billing scenarios",
    codes: [
      { code: "F0", label: "Reserved" },
      { code: "F1", label: "Reserved" },
      { code: "F2", label: "Reserved" },
      { code: "F3", label: "Reserved" },
      { code: "F4", label: "Reserved" },
      { code: "F5", label: "Reserved" },
      { code: "F6", label: "Reserved" },
      { code: "F7", label: "Reserved" },
      { code: "F8", label: "Reserved" },
      { code: "F9", label: "Reserved" }
    ]
  },

  // G0–G9: Additional codes
  Additional_Codes_G: {
    color: "#bdc3c7",
    icon: "Circle",
    description: "Additional codes reserved for future use or special applications",
    codes: [
      { code: "G0", label: "Reserved" },
      { code: "G1", label: "Reserved" },
      { code: "G2", label: "Reserved" },
      { code: "G3", label: "Reserved" },
      { code: "G4", label: "Reserved" },
      { code: "G5", label: "Reserved" },
      { code: "G6", label: "Reserved" },
      { code: "G7", label: "Reserved" },
      { code: "G8", label: "Reserved" },
      { code: "G9", label: "Reserved" }
    ]
  }
};




export const priceSources = {
  cms_opps_b: {
    name: "OutPatient Hospital"
  },
  cms_out_geosvc_22: {
    name: "OutPatient"
  },
  cms_inpatient_geosvc: {
    name: "INPatient"
  },
  cms_pfs_pprrvu: {
    name: "Physician Fee Schedule (Primary)"
  },
  cms_anes_23: {
    name: "Anesthesia Fee Schedule"
  },
  cms_clab_fee_schedule: {
    name: "CLAB Fee Schedule"
  },
  cms_dme_prvsvc: {
    name: "DME PRVSVC"
  },
  cms_asp_22: {
    name: "ASP"
  },
  cms_geosvc: {
    name: "CMS GEO"
  },
  cms: {
    name: "CMS"
  },
  cms_fee_schedule: {
    name: "CMS Fee Schedule"
  }
}

export const cptRebaseCodes = {
  "01": "priced as billed",
  "03": "contract Rate",
  "07": "rejected",
  "10": "healthy code"
}

export const dateCodesLean = {
  "472": "Service Date",
  "434": "Statement From Date",
  "435": "Statement To Date",
  "096": "Discharge Date",
  "050": "Received Date",
  "439": "Accident Date",
  "232": "Admission Date"
}

export const dateCodes = {
  "007": "Effective Date",
  "050": "Received Date",
  "051": "Service Period",
  "052": "Discharge Date",
  "053": "Assumed and Relinquished Care Dates",
  "054": "Admission Date",
  "055": "Birth Date",
  "056": "Death Date",
  "057": "Disability Begin Date",
  "058": "Disability End Date",
  "060": "Acute Manifestation Date",
  "061": "Onset of Symptoms/Illness",
  "064": "Last Menstrual Period",
  "065": "Last X-ray Date",
  "067": "Referral Date",
  "070": "Report Date",
  "072": "Date of Last Visit",
  "073": "First Visit or Consultation Date",
  "074": "Date of Last Seen by Referring Provider",
  "090": "Report Start Date",
  "091": "Report End Date",
  "096": "Discharge Date",
  "097": "Discharge Hour",
  "098": "Onset of Current Illness",
  "099": "Latest Visit or Consultation Date",
  "100": "Most Recent Hemoglobin A1c Test Date",
  "101": "Most Recent Foot Exam Date",
  "102": "Most Recent Eye Exam Date",
  "103": "Last Dental Exam Date",
  "132": "Referral Date",
  "135": "Treatment Plan Date",
  "136": "Initial Treatment Date",
  "137": "Last Certification Date",
  "138": "Certification Revision Date",
  "139": "Begin Therapy Date",
  "140": "Last Therapy Date",
  "141": "Date of Current Illness/Injury",
  "144": "Date of First Symptom",
  "150": "Latest Hemoglobin Test Date",
  "291": "Plan Begin Date",
  "292": "Plan End Date",
  "304": "Latest Visit Date",
  "307": "Eligibility Begin Date",
  "318": "Coverage Expiration Date",
  "340": "Claim Effective Date",
  "341": "Claim Termination Date",
  "344": "Spouse Employment Begin Date",
  "345": "Spouse Employment End Date",
  "348": "Medicare Effective Date",
  "349": "Medicare Termination Date",
  "356": "Primary Care Provider Enrollment Date",
  "357": "Primary Care Provider Termination Date",
  "361": "Date of Injury",
  "435": "Statement To Date",
  "434": "Statement From Date",
  "439": "Accident Date",
  "444": "Begin Therapy Date",
  "453": "Initial Contact Date",
  "454": "Initial Treatment Date",
  "455": "Last Seen Date",
  "471": "Prescription Date",
  "472": "Service Date",
  "600": "Initial Disability Date",
  "601": "Recurrent Disability Date",
  "607": "Certification Revision Date",
  "736": "Property Casualty Date of First Contact",
  "738": "Begin Date of Treatment",
  "739": "Last Date of Treatment",
  "741": "Provider Signature Date",
  "742": "Date of Acute Manifestation",
  "743": "First Visit Date",
  "807": "Eligibility Date",
  "818": "Spouse Employment Begin Date",
  "819": "Spouse Employment End Date"
}


export const cptData = {
  Evaluation_And_Management: {
    rangeStart: 99202,
    rangeEnd: 99499,
    description: "Office visits, consultations, hospital care, preventive care",
    color: "#2b6cb0",
    icon: "Stethoscope",
    subsections: {
      Office_Visits: {
        rangeStart: 99202,
        rangeEnd: 99215,
        color: "#3b82c4",
        icon: "ClipboardList"
      },
      Preventive_Medicine: {
        rangeStart: 99381,
        rangeEnd: 99397,
        color: "#4a90d6",
        icon: "ShieldCheck"
      },
      Hospital_Inpatient_Care: {
        rangeStart: 99221,
        rangeEnd: 99239,
        color: "#1e4e89",
        icon: "Hospital"
      },
      Care_Management: {
        rangeStart: 99487,
        rangeEnd: 99489,
        color: "#5ea0e8",
        icon: "Activity"
      }
    }
  },
  Anesthesia: {
    rangeStart: 100,
    rangeEnd: 1999,
    description: "Anesthesia for procedures by site or circumstance",
    color: "#6b46c1",
    icon: "Syringe",
    subsections: {
      Head: {
        rangeStart: 100,
        rangeEnd: 222,
        color: "#7e57c2",
        icon: "Headphones" // Represents head/ear
      },
      Neck: {
        rangeStart: 300,
        rangeEnd: 352,
        color: "#8b5cf6",
        icon: null
      },
      Thorax: {
        rangeStart: 400,
        rangeEnd: 474,
        color: "#6d28d9",
        icon: "Wind"
      },
      Intrathoracic: {
        rangeStart: 500,
        rangeEnd: 580,
        color: "#5b21b6",
        icon: null
      },
      Spine_And_Spinal_Cord: {
        rangeStart: 600,
        rangeEnd: 670,
        color: "#4c1d95",
        icon: "Brain"
      },
      Upper_Abdomen: {
        rangeStart: 700,
        rangeEnd: 797,
        color: "#7c3aed",
        icon: "Utensils"
      },
      Lower_Abdomen: {
        rangeStart: 800,
        rangeEnd: 882,
        color: "#a855f7",
        icon: "Toilet"
      },
      Perineum: {
        rangeStart: 902,
        rangeEnd: 952,
        color: "#9333ea",
        icon: null
      },
      Pelvis_Non_Obstetric: {
        rangeStart: 1112,
        rangeEnd: 1173,
        color: "#6b21a8",
        icon: null
      },
      Upper_Leg_Except_Hip: {
        rangeStart: 1200,
        rangeEnd: 1274,
        color: "#581c87",
        icon: null
      },
      Hip_And_Lower_Leg: {
        rangeStart: 1320,
        rangeEnd: 1444,
        color: "#c084fc",
        icon: null
      },
      Shoulder_And_Axilla: {
        rangeStart: 1610,
        rangeEnd: 1682,
        color: "#a78bfa",
        icon: null
      },
      Upper_Arm_And_Elbow: {
        rangeStart: 1710,
        rangeEnd: 1782,
        color: "#8b5cf6",
        icon: null
      },
      Forearm_Wrist_And_Hand: {
        rangeStart: 1810,
        rangeEnd: 1860,
        color: "#7c3aed",
        icon: null
      },
      Radiologic_Procedures: {
        rangeStart: 1916,
        rangeEnd: 1936,
        color: "#5b21b6",
        icon: "ScanLine"
      },
      Burn_Excisions_Debridement: {
        rangeStart: 1951,
        rangeEnd: 1953,
        color: "#c026d3",
        icon: null
      },
      Obstetric: {
        rangeStart: 1958,
        rangeEnd: 1969,
        color: "#e879f9",
        icon: "Baby"
      }
    }
  },
  
  Surgery: {
    rangeStart: 10021,
    rangeEnd: 69990,
    description: "Surgical procedures grouped by anatomical region or system",
    color: "#c53030",
    icon: "Slice",
    subsections: {
      Integumentary: {
        rangeStart: 10021,
        rangeEnd: 19499,
        color: "#e53e3e",
        icon: "Layers"
      },
      Musculoskeletal: {
        rangeStart: 20000,
        rangeEnd: 29999,
        color: "#cc2929",
        icon: null
      },
      Respiratory: {
        rangeStart: 30000,
        rangeEnd: 32999,
        color: "#b22222",
        icon: "Wind"
      },
      Cardiovascular: {
        rangeStart: 33010,
        rangeEnd: 37799,
        color: "#9b1c1c",
        icon: "Activity"
      },
      Digestive: {
        rangeStart: 40490,
        rangeEnd: 49999,
        color: "#ef4444",
        icon: "Utensils"
      },
      Urinary: {
        rangeStart: 50010,
        rangeEnd: 53899,
        color: "#d63d3d",
        icon: "Droplet"
      },
      Male_Genital: {
        rangeStart: 54000,
        rangeEnd: 55899,
        color: "#aa2222",
        icon: null
      },
      Female_Genital: {
        rangeStart: 56405,
        rangeEnd: 58999,
        color: "#871818",
        icon: null
      },
      Maternity_Delivery: {
        rangeStart: 59000,
        rangeEnd: 59899,
        color: "#f87171",
        icon: "Baby"
      },
      Nervous_System: {
        rangeStart: 61000,
        rangeEnd: 64999,
        color: "#c22525",
        icon: "Brain"
      },
      Eye_And_Ocular_Adnexa: {
        rangeStart: 65091,
        rangeEnd: 68899,
        color: "#f56565",
        icon: "Eye"
      },
      Auditory_System: {
        rangeStart: 69000,
        rangeEnd: 69990,
        color: "#e02424",
        icon: "Ear"
      }
    }
  },
  Radiology: {
    rangeStart: 70010,
    rangeEnd: 79999,
    description: "Imaging services (X-ray, CT, MRI, ultrasound)",
    color: "#d69e2e",
    icon: "ScanLine",
    subsections: {
      Diagnostic_Radiology: {
        rangeStart: 70010,
        rangeEnd: 76499,
        color: "#e6b422",
        icon: "Stethoscope" // general diagnostic imaging
      },
      Diagnostic_Ultrasound: {
        rangeStart: 76500,
        rangeEnd: 76999,
        color: "#f6c244",
        icon: "Waveform"
      },
      Radiologic_Guidance: {
        rangeStart: 77001,
        rangeEnd: 77022,
        color: "#facc15",
        icon: "Target"
      },
      Mammography: {
        rangeStart: 77046,
        rangeEnd: 77067,
        color: "#eab308",
        icon: "Breast" // if not available, set to null
      },
      Bone_Density: {
        rangeStart: 77071,
        rangeEnd: 77086,
        color: "#ca8a04",
        icon: null
      },
      CT_MRI: {
        rangeStart: 77090,
        rangeEnd: 77999,
        color: "#b7791f",
        icon: "BrainCircuit"
      },
      Nuclear_Medicine: {
        rangeStart: 78012,
        rangeEnd: 78999,
        color: "#a16207",
        icon: "Radioactive"
      },
      Interventional_Radiology: {
        rangeStart: 79005,
        rangeEnd: 79999,
        color: "#854d0e",
        icon: null
      }
    }
  },
  Pathology_And_Laboratory: {
    rangeStart: 80047,
    rangeEnd: 89398,
    description: "Lab tests, pathology exams, panels",
    color: "#9c4221",
    icon: "TestTube2",
    subsections: {
      Organ_Disease_Panels: {
        rangeStart: 80047,
        rangeEnd: 80081,
        color: "#b44d30",
        icon: "LayoutPanelLeft"
      },
      Drug_Tests: {
        rangeStart: 80100,
        rangeEnd: 80299,
        color: "#cc5a33",
        icon: "Pill"
      },
      Therapeutic_Drug_Assays: {
        rangeStart: 80305,
        rangeEnd: 80377,
        color: "#e56238",
        icon: null
      },
      Chemistry: {
        rangeStart: 82009,
        rangeEnd: 84999,
        color: "#f97316",
        icon: null
      },
      Hematology: {
        rangeStart: 85002,
        rangeEnd: 85999,
        color: "#d94820",
        icon: "Droplet"
      },
      Immunology: {
        rangeStart: 86000,
        rangeEnd: 86849,
        color: "#b91c1c",
        icon: "ShieldCheck"
      },
      Microbiology: {
        rangeStart: 87003,
        rangeEnd: 87999,
        color: "#9f1239",
        icon: "Bacteria"
      },
      Cytopathology: {
        rangeStart: 88104,
        rangeEnd: 88199,
        color: "#7f1d1d",
        icon: null
      },
      Surgical_Pathology: {
        rangeStart: 88300,
        rangeEnd: 88399,
        color: "#5c1d1d",
        icon: "Scalpel"
      },
      In_Situ_Hybridization: {
        rangeStart: 88365,
        rangeEnd: 88374,
        color: "#6d281d",
        icon: null
      },
      Cytogenetic_Studies: {
        rangeStart: 88230,
        rangeEnd: 88299,
        color: "#7c2d12",
        icon: "DNA"
      },
      Miscellaneous: {
        rangeStart: 89049,
        rangeEnd: 89398,
        color: "#78350f",
        icon: null
      }
    }
  },
  Medicine: {
    rangeStart: 90281,
    rangeEnd: 99607,
    description: "Non-surgical procedures, immunizations, tests, psychiatry",
    color: "#2f855a",
    icon: "HeartPulse",
    subsections: {
      Immunization_Administration: {
        rangeStart: 90460,
        rangeEnd: 90474,
        color: "#38a169",
        icon: "Syringe"
      },
      Cardiovascular_Tests: {
        rangeStart: 93000,
        rangeEnd: 93999,
        color: "#48bb78",
        icon: "Activity"
      },
      Pulmonary_Function: {
        rangeStart: 94010,
        rangeEnd: 94799,
        color: "#276749",
        icon: "Wind"
      },
      Psychiatric_Services: {
        rangeStart: 90785,
        rangeEnd: 90899,
        color: "#3c7f67",
        icon: "UserCog"
      },
      Vision_and_Ophthalmology: {
        rangeStart: 92002,
        rangeEnd: 92499,
        color: "#68d391",
        icon: "Eye"
      },
      Other_Evaluations: {
        rangeStart: 96101,
        rangeEnd: 96127,
        color: "#22543d",
        icon: "FileSearch"
      }
    }
  }
};

// Export a unique, sorted array of all Lucide icon names used in cptData
export const cptIconNames = Array.from(new Set([
  ...Object.values(cptData).map(section => section.icon),
  ...Object.values(cptData).flatMap(section =>
    section.subsections ? Object.values(section.subsections).map(sub => sub.icon) : []
  )
])).filter(Boolean).sort();



export const jCodeData = {
  Anesthetics: {
    rangeStart: "J0120",
    rangeEnd: "J0599",
    color: "#7f8c8d",
    icon: "Droplet",
    subsections: {
      Local: { rangeStart: "J0120", rangeEnd: "J0179", icon: "Thermometer", color: "#95a5a6" },
      General: { rangeStart: "J0180", rangeEnd: "J0599", icon: null, color: "#bdc3c7" }
    }
  },
  AntiInfectives: {
    rangeStart: "J0600",
    rangeEnd: "J0999",
    color: "#3498db",
    icon: "ShieldCheck",
    subsections: {
      Antibiotics: { rangeStart: "J0600", rangeEnd: "J0699", icon: "Pill", color: "#2980b9" },
      Antivirals: { rangeStart: "J0700", rangeEnd: "J0799", icon: "Bug", color: "#5dade2" },
      Immunoglobulins: { rangeStart: "J0800", rangeEnd: "J0899", icon: "Droplets", color: "#85c1e9" },
      Other: { rangeStart: "J0900", rangeEnd: "J0999", icon: null, color: "#d6eaf8" }
    }
  },
  Cardiovascular: {
    rangeStart: "J1000",
    rangeEnd: "J1499",
    color: "#1abc9c",
    icon: "Activity",
    subsections: {
      Antihypertensives: { rangeStart: "J1000", rangeEnd: "J1099", icon: null, color: "#16a085" },
      Diuretics: { rangeStart: "J1100", rangeEnd: "J1199", icon: "Droplet", color: "#48c9b0" },
      Antiarrhythmics: { rangeStart: "J1200", rangeEnd: "J1299", icon: null, color: "#76d7c4" },
      Vasopressors: { rangeStart: "J1300", rangeEnd: "J1399", icon: "TrendingUp", color: "#a2d9ce" },
      Other: { rangeStart: "J1400", rangeEnd: "J1499", icon: null, color: "#d1f2eb" }
    }
  },
  PainManagement: {
    rangeStart: "J2000",
    rangeEnd: "J2799",
    color: "#e67e22",
    icon: "Zap",
    subsections: {
      Opioids: { rangeStart: "J2000", rangeEnd: "J2199", icon: "Cross", color: "#e59866" },
      NSAIDs: { rangeStart: "J2200", rangeEnd: "J2399", icon: null, color: "#edbb99" },
      Antiemetics: { rangeStart: "J2400", rangeEnd: "J2499", icon: "Smile", color: "#27ae60" },
      Other: { rangeStart: "J2500", rangeEnd: "J2799", icon: null, color: "#f0b27a" }
    }
  },
  Endocrine: {
    rangeStart: "J2800",
    rangeEnd: "J3499",
    color: "#f39c12",
    icon: "CircleDot",
    subsections: {
      Insulin: { rangeStart: "J2800", rangeEnd: "J2899", icon: "Droplet", color: "#f4d03f" },
      Steroids: { rangeStart: "J2900", rangeEnd: "J2999", icon: null, color: "#f7dc6f" },
      Thyroid: { rangeStart: "J3000", rangeEnd: "J3199", icon: null, color: "#f9e79f" },
      Other: { rangeStart: "J3200", rangeEnd: "J3499", icon: null, color: "#fcf3cf" }
    }
  },
  Miscellaneous: {
    rangeStart: "J3500",
    rangeEnd: "J8999",
    color: "#95a5a6",
    icon: "Package",
    subsections: {
      Diagnostics: { rangeStart: "J3500", rangeEnd: "J3999", icon: "Search", color: "#bdc3c7" },
      Vaccines: { rangeStart: "J4000", rangeEnd: "J4399", icon: "Syringe", color: "#45b39d" },
      Allergy: { rangeStart: "J4400", rangeEnd: "J4999", icon: "Feather", color: "#73c6b6" },
      Biologics: { rangeStart: "J5000", rangeEnd: "J5999", icon: "Settings", color: "#7f8c8d" },
      Other: { rangeStart: "J6000", rangeEnd: "J8999", icon: null, color: "#abb2b9" }
    }
  },
  Chemotherapy: {
    rangeStart: "J9000",
    rangeEnd: "J9999",
    color: "#c0392b",
    icon: "FlaskConical",
    subsections: {
      Antineoplastics: { rangeStart: "J9000", rangeEnd: "J9099", icon: "Radiation", color: "#e74c3c" },
      Monoclonals: { rangeStart: "J9100", rangeEnd: "J9199", icon: "Target", color: "#d98880" },
      Hormonal: { rangeStart: "J9200", rangeEnd: "J9299", icon: "Flame", color: "#f1948a" },
      EnzymeInhibitors: { rangeStart: "J9300", rangeEnd: "J9399", icon: null, color: "#f5b7b1" },
      ChemoAdjuncts: { rangeStart: "J9400", rangeEnd: "J9499", icon: null, color: "#f9e79f" },
      Supportive: { rangeStart: "J9500", rangeEnd: "J9999", icon: "HeartPulse", color: "#fad7a0" }
    }
  }
};

export const refQualifiers = {
  "9F": "Referral Number",
  "EA": "Medical Record Number",
  "D9": "Claim Identifier (Payer Assigned or Internal Tracking)",
  "F8": "Original Reference Number (used in resubmissions)",
  "G1": "Prior Authorization Number",
  "1K": "Payer Claim Control Number",
  "IG": "Insurance Policy Number",
  "X4": "CLIA Number (Clinical Laboratory Improvement Amendments)",
  "Y4": "Claim Attachment Control Number",
  "F5": "Patient Account Number",
  "D7": "Submission Number",
  "A6": "Provider Control Number",
  "T4": "Clinical Trial Number",
  "2U": "Payer Claim Number",
  "BB": "Authorization Number",
  "1F": "File Identification Number",
  "SY": "Social Security Number",
  "F6": "Health Insurance Claim Number (HICN)",
  "HZ": "Contract Number",
  "JD": "User Identification Number"
}


export const revenueCodes = {
  RoomAndBoard: {
    rangeStart: "0100",
    rangeEnd: "0219",
    color: "#3498db",
    icon: "Bed",
    subsections: {
      General: { rangeStart: "0100", rangeEnd: "0129", icon: "Hotel", color: "#5dade2" },
      ICU: { rangeStart: "0200", rangeEnd: "0209", icon: "Activity", color: "#2980b9" },
      CCU: { rangeStart: "0210", rangeEnd: "0219", icon: null, color: "#aed6f1" }
    }
  },
  AncillaryServices: {
    rangeStart: "0220",
    rangeEnd: "0999",
    color: "#2ecc71",
    icon: "Package",
    subsections: {
      Nursing: { rangeStart: "0230", rangeEnd: "0239", icon: "HeartPulse", color: "#58d68d" },
      Pharmacy: { rangeStart: "0250", rangeEnd: "0259", icon: "Pill", color: "#27ae60" },
      IVTherapy: { rangeStart: "0260", rangeEnd: "0269", icon: "Syringe", color: "#1e8449" },
      Respiratory: { rangeStart: "0410", rangeEnd: "0419", icon: "Wind", color: "#a2d9ce" },
      OccupationalTherapy: { rangeStart: "0430", rangeEnd: "0439", icon: "Armchair", color: "#52be80" },
      PhysicalTherapy: { rangeStart: "0420", rangeEnd: "0429", icon: "Run", color: "#45b39d" },
      SpeechTherapy: { rangeStart: "0440", rangeEnd: "0449", icon: "Mic", color: "#16a085" },
      Radiology: { rangeStart: "0320", rangeEnd: "0359", icon: "ScanLine", color: "#7fb3d5" },
      Laboratory: { rangeStart: "0300", rangeEnd: "0319", icon: "TestTube2", color: "#1abc9c" },
      OperatingRoom: { rangeStart: "0360", rangeEnd: "0369", icon: "Scissors", color: "#e67e22" },
      Anesthesia: { rangeStart: "0370", rangeEnd: "0379", icon: "Droplet", color: "#f5b041" },
      RecoveryRoom: { rangeStart: "0380", rangeEnd: "0389", icon: "Heartbeat", color: "#f39c12" },
      Cardiology: { rangeStart: "0480", rangeEnd: "0489", icon: "Activity", color: "#c0392b" },
      ER: { rangeStart: "0450", rangeEnd: "0459", icon: "AlarmClock", color: "#e74c3c" },
      Clinic: { rangeStart: "0510", rangeEnd: "0519", icon: "Stethoscope", color: "#f1948a" },
      Dialysis: { rangeStart: "0800", rangeEnd: "0809", icon: "Droplets", color: "#5dade2" },
      Ambulance: { rangeStart: "0540", rangeEnd: "0549", icon: "Bus", color: "#d98880" }
    }
  },
  BillingAndSupplies: {
    rangeStart: "0620",
    rangeEnd: "0639",
    color: "#9b59b6",
    icon: "CreditCard",
    subsections: {
      RevenueCodes: { rangeStart: "0620", rangeEnd: "0629", icon: "FileText", color: "#af7ac5" },
      Supplies: { rangeStart: "0630", rangeEnd: "0639", icon: "Box", color: "#bb8fce" }
    }
  },
  OtherServices: {
    rangeStart: "0900",
    rangeEnd: "0999",
    color: "#34495e",
    icon: "Settings",
    subsections: {
      BehavioralHealth: { rangeStart: "0900", rangeEnd: "0919", icon: "Brain", color: "#566573" },
      Hospice: { rangeStart: "0650", rangeEnd: "0659", icon: "Heart", color: "#d5dbdb" },
      HomeHealth: { rangeStart: "0600", rangeEnd: "0609", icon: "Home", color: "#7dcea0" },
      Telemedicine: { rangeStart: "0780", rangeEnd: "0789", icon: "Video", color: "#48c9b0" }
    }
  }
};


export const cCodeData = {
  "Outpatient_Devices": {
    "rangeStart": "C1700",
    "rangeEnd": "C1799",
    "color": "#1abc9c",
    "icon": "Microscope",
    "subsections": {
      "Implantable_Devices": {
        "rangeStart": "C1700",
        "rangeEnd": "C1729",
        "icon": "SquareStack",
        "color": "#16a085"
      },
      "Pacemakers_And_Leads": {
        "rangeStart": "C1730",
        "rangeEnd": "C1759",
        "icon": "HeartPulse",
        "color": "#48c9b0"
      },
      "Neurostimulators": {
        "rangeStart": "C1760",
        "rangeEnd": "C1779",
        "icon": null,
        "color": "#76d7c4"
      },
      "Orthopedic_Implants": {
        "rangeStart": "C1780",
        "rangeEnd": "C1799",
        "icon": "Bone",
        "color": "#a2d9ce"
      }
    }
  },
  "Drug_And_Biologics": {
    "rangeStart": "C9000",
    "rangeEnd": "C9399",
    "color": "#d35400",
    "icon": "Syringe",
    "subsections": {
      "Chemotherapy": {
        "rangeStart": "C9000",
        "rangeEnd": "C9099",
        "icon": "FlaskRound",
        "color": "#e67e22"
      },
      "Immunotherapy": {
        "rangeStart": "C9100",
        "rangeEnd": "C9199",
        "icon": null,
        "color": "#eb984e"
      },
      "Hormone_Therapy": {
        "rangeStart": "C9200",
        "rangeEnd": "C9299",
        "icon": "Droplet",
        "color": "#f0b27a"
      },
      "Other": {
        "rangeStart": "C9300",
        "rangeEnd": "C9399",
        "icon": null,
        "color": "#f5cba7"
      }
    }
  },
  "Surgical_Kits_And_Supplies": {
    "rangeStart": "C1800",
    "rangeEnd": "C1899",
    "color": "#5dade2",
    "icon": "Scalpel",
    "subsections": {
      "Surgical_Kits": {
        "rangeStart": "C1800",
        "rangeEnd": "C1849",
        "icon": "Package",
        "color": "#3498db"
      },
      "Hemostatic_Agents": {
        "rangeStart": "C1850",
        "rangeEnd": "C1874",
        "icon": null,
        "color": "#85c1e9"
      },
      "Orthotic_Supplies": {
        "rangeStart": "C1875",
        "rangeEnd": "C1899",
        "icon": "Footprints",
        "color": "#aed6f1"
      }
    }
  }
}


export const ediIcons = {
  envelope: "Mail",
  functionalGroup: "Layers3",
  transaction: "FileText",
  provider: "Hospital",
  subscriber: "User",
  patient: "UserRound",
  claimInfo: "FileSearch",
  diagnoses: "Heartbeat",
  pricing: "BadgeDollarSign",
  renderingProvider: "UserCheck"
};

export const ediKeys = {
  "submitter": {
    "desc": "The entity sending the 837 claim (usually a billing service or clearinghouse). NM1*41",
    "icon": "Send"
  },
  "receiver": {
    "desc": "The entity receiving the claim file (typically a payer’s intermediary). NM1*40",
    "icon": "Inbox"
  },
  "provider": {
    "desc": "The billing provider organization responsible for the claim. NM1*85",
    "icon": "Hospital"
  },
  "subscriber": {
    "desc": "The insured individual or person whose health plan covers the patient. NM1*IL",
    "icon": "IdCard"
  },
  "patient": {
    "desc": "Demographic details of the patient receiving care, if different from subscriber. DMG segment",
    "icon": "User"
  },
  "payer": {
    "desc": "The insurance company or plan expected to adjudicate and pay the claim. NM1*PR",
    "icon": "CreditCard"
  },
  "serviceProvider": {
    "desc": "The pay-to provider address for payment remittance. NM1*87",
    "icon": "MapPin"
  },
  "claimInfo": {
    "desc": "Core claim data including ID, charge amount, facility type, and references. CLM, DTP, CL1, REF segments",
    "icon": "FileText"
  },
  "diagnoses": {
    "desc": "ICD-10 diagnosis codes tied to the claim, including primary and secondary. HI segment",
    "icon": "Heartbeat"
  },
  "pricing": {
    "desc": "Submitted and allowed amounts, discounts, and reimbursement methodology. HCP segment",
    "icon": "DollarSign"
  },
  "renderingProvider": {
    "desc": "The individual clinician responsible for performing the services. NM1*71",
    "icon": "Stethoscope"
  }
}


